import Avatar from "./avatar"
import AvatarGroup from "./avatar_group"

Avatar.Group = AvatarGroup

export default Avatar
